// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FjiNv{display:flex;flex-wrap:wrap;gap:.75rem 1.5rem}.Tp_Tk,.FjiNv{align-items:center}.Tp_Tk{display:inline-flex;gap:.5rem}.BNM6R{color:var(--anchore-color-gray-600);font-size:.85rem;font-weight:700}.Y5oCD.ui.label{font-size:1.125rem;padding:.25rem}.Y5oCD.ui.label>svg{margin-right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `FjiNv`,
	"indicator": `Tp_Tk`,
	"label": `BNM6R`,
	"kevLabel": `Y5oCD`
};
module.exports = ___CSS_LOADER_EXPORT___;
